import { environment } from 'src/environments/environment';
import { EnvironmentName } from '../config';
const standaloneUrls = [
  'https://app.afasatjts.com',
  'https://staging.afasatjts.com',
  'http://localhost:4200',
];

/**
 * Determines the environment type based on the current location origin.
 *
 * @returns {EnvironmentName} The type of environment, either `STANDALONE` or `EPIC`.
 *
 * The function checks if the current location origin is either 'https://staging.afasatjts.com'
 * or 'http://localhost:4200'. If it matches any of these, it returns `EnvironmentType.STANDALONE`.
 * Otherwise, it returns `EnvironmentType.EPIC`.
 */
export const getEnvironmentName = (): EnvironmentName => {
  let environmentType;
  if (standaloneUrls.indexOf(location.origin) >= 0 && !environment.isEpic) {
    environmentType = EnvironmentName.STANDALONE;
  } else {
    environmentType = EnvironmentName.EPIC;
  }
  return environmentType;
};
